<template>
  <div class="hello">
    <div v-if="formProcess > 0">
      <div class="alert alert-success" v-if="formProcess == 200">
        {{ t.form.success }}
      </div>
      <div class="alert alert-danger" v-if="formProcess == 403">
        {{ t.error.access_denied_content }}
      </div>
      <div class="alert alert-danger" v-if="formProcess == 404">
        {{ t.error.notfound_content_list }}
      </div>
    </div>
    <div class="listy">
      <div class="label">{{ t.template_name }}</div>
      <input class="form-control" type="text" v-model="name" />
    </div>
    <div class="listy pt-0">
      <input type="button" class="btn col-12 btn-lg btn-primary" @click="createTemp" :value="t.create_template"/>
    </div>
  </div>
</template>

<script>
  import Feed from '@/mixins/feed';
  export default {
    name: 'templateForm',
    mixins: [Feed],
    data () {
      return {
        t: this.$root.t,
        name: '',
        formProcess: 0
      }
    },
    methods: {
      createTemp (d) {
        this.createTemplate({name: this.name}).then(response => {
          this.$emit('added', response.body);
          this.formProcess = 200;

          setTimeout(() => {
            this.formProcess = 0;
          }, 5000)
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/element/templateForm.vue